var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "field" }, [
    _c("label", { staticClass: "label", attrs: { for: _vm.id } }, [
      _vm._v("\n    RFC\n  ")
    ]),
    _c(
      "div",
      { staticClass: "control has-icons-left", class: _vm.controlClass },
      [
        _c("input", {
          ref: "rfc",
          staticClass: "input",
          attrs: {
            id: _vm.id,
            name: _vm.name,
            maxlength: "13",
            placeholder: _vm.placeholder,
            pattern: _vm.rfcPattern,
            disabled: _vm.disabled,
            required: _vm.required,
            readonly: _vm.readonly
          },
          domProps: { value: _vm.value },
          on: { input: _vm.onInput, change: _vm.onChange }
        }),
        _c("BIcon", {
          staticClass: "is-unselectable is-left",
          attrs: { icon: "fingerprint", size: "is-small" }
        }),
        _vm.isValid && _vm.validIcon
          ? _c("span", { staticClass: "icon is-small is-right" }, [
              _c(
                "i",
                {
                  staticClass: "material-icons is-unselectable has-text-success"
                },
                [_vm._v("\n        done\n      ")]
              )
            ])
          : _vm._e(),
        _c("p", { staticClass: "help is-danger" }, [
          _vm._v("\n      El valor proporcionado no es un RFC válido\n    ")
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }